import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';
import ForgotPasswordDialog from '../components/ForgotPasswordDialog';

const Login = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.email, form.password);
      toast({ title: 'Bienvenue !' });
      navigate('/');
    } catch (err) {
      toast({ title: 'Erreur', description: err.response?.data?.detail || 'Identifiants invalides' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-white border border-[#E8E0D0] rounded-2xl p-8 shadow-sm">
        <h1 className="font-serif text-3xl font-semibold text-[#1F4D3F]">Connexion</h1>
        <p className="text-sm text-[#7A6F5C] mt-1">Accédez à votre compte Comptoir-Online</p>

        <form onSubmit={submit} className="space-y-4 mt-6">
          <div>
            <label className="text-sm text-[#2D2A26] mb-1.5 block">Email</label>
            <Input name="email" type="email" data-testid="login-email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="vous@email.dz" />
          </div>
          <div>
            <div className="flex items-center justify-between mb-1.5">
              <label className="text-sm text-[#2D2A26]">Mot de passe</label>
              <ForgotPasswordDialog />
            </div>
            <Input name="password" type="password" data-testid="login-password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" />
          </div>
          <Button type="submit" data-testid="login-submit" disabled={busy} className="w-full h-11 bg-[#1F4D3F] hover:bg-[#173B30] text-white">
            {busy ? 'Connexion...' : 'Se connecter'}
          </Button>
        </form>

        <p className="text-sm text-[#7A6F5C] text-center mt-6">
          Pas encore de compte ? <Link to="/inscription" className="text-[#1F4D3F] font-medium hover:underline">Créer un compte</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
